import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal, notification } from "antd";
import { CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { customInput } from "../../../../../../../common/custom-input";
import SingleUploadField from "../../../../../../../common/new-core-ui/SingleUploadField";
import { Strings } from "../../../../../../../../dataProvider/localize";
import styles from "../../../../../JobStyle.module.css";

const FORM_NAME = "job_swms_method_item_type_add_edit_modal";

function DynamicMethodItemTypeAddEditModal({ visible, mode, handleSubmit, onClose, initialValues = {} }) {
  const [saving, setSaving] = useState(false);

  const onModalSubmit = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    handleSubmit(onSubmit)(event);
  };

  const onSubmit = (values) => {
    if (values.linked_documents && (!values.linked_documents.isUploaded || values.linked_documents.isFailed)) {
      notification.error({
        message: Strings.error_title,
        description: "One or more files are still uploading or they failed to upload.",
        className: "ant-error"
      });
      return;
    }

    if (!values.method_item || !String(values.method_item).trim()) {
      notification.error({
        message: Strings.error_title,
        description: "Name is required.",
        className: "ant-error"
      });
      return;
    }

    setSaving(true);

    const resolved = {
      ...initialValues,
      method_item: String(values.method_item).trim(),
      linked_documents: values.linked_documents || null
    };

    onClose(true, resolved);
    setSaving(false);
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={() => onClose(false)}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      width={700}
      getContainer={() => document.body}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <form onSubmit={onModalSubmit}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className={styles.ModalHeading}>{mode === "Edit" ? "Edit Method Item" : "Add Method Item"}</div>
                <hr />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Name</div>
                <Field
                  component={customInput}
                  name="method_item"
                  disabled={saving}
                  autoComplete="off"
                  className={styles.TextField}
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Linked Document</div>
                <Field
                  name="linked_documents"
                  disabled={saving}
                  showDragger
                  component={SingleUploadField}
                  s3UploadPath="swms/job/method-items"
                  mimeType=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.webp"
                  flexDirection="column"
                  fieldName="linked_documents"
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
                {saving ? <CircularProgress size={20} /> : null}
                <button type="button" className={styles.OutlinedButton} onClick={() => onClose(false)} disabled={saving}>
                  Cancel
                </button>
                <button type="submit" className={styles.PrimaryButton} disabled={saving}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: true
})(DynamicMethodItemTypeAddEditModal);
